<template>
  <div class="login-form admin-login">
    <div class="admin-badge">
      <i class="fa fa-shield"></i>
      <span>管理后台登录</span>
    </div>
    <div class="form-group">
      <input
        type="text"
        name="username"
        v-model="login.username"
        autocomplete="off"
        class="text-input"
        placeholder="管理员账号（默认 admin）"
      />
    </div>
    <div class="form-group">
      <input
        type="password"
        name="password"
        v-model="login.password"
        @keyup.enter="submit"
        autocomplete="off"
        class="text-input"
        placeholder="密码（默认 123456）"
      />
    </div>
    <div class="form-options">
      <span class="back-link text-hover" @click="$emit('input','LoginForm')">
        <i class="fa fa-angle-left"></i> 返回用户登录
      </span>
    </div>
    <div class="form-submit">
      <Button :loading="loading" block color="primary" size="l" @click="submit">进入管理后台</Button>
    </div>
    <div class="form-footer">
      <span>仅限平台运营管理员登录</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdminLogin',
  data() {
    return {
      login: {
        username: "admin",
        password: "",
      },
      loading: false
    }
  },
  methods: {
    submit() {
      if (this.login.username && this.login.password) {
        this.loading = true;
        this.$api.common.login({mobile: this.login.username, password: this.login.password}).then(() => {
          window.location.replace('/admin/dashboard');
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.$Message.error('请输入管理员账号和密码');
      }
    }
  }
}
</script>
<style lang="less" scoped>
@brand-blue: #3788ee;
@text-primary: #1a1a1a;
@text-secondary: #999999;
@border-color: #e5e5e5;

.admin-login {
  .admin-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 32px;
    padding: 10px;
    border-radius: 8px;
    background: rgba(55, 136, 238, 0.08);
    color: @brand-blue;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .text-input {
    width: 100%;
    height: 48px;
    border: 1px solid @border-color;
    border-radius: 8px;
    padding: 0 16px;
    font-size: 15px;
    color: @text-primary;
    outline: none;
    transition: all 0.3s ease;
    box-sizing: border-box;
    background: #fff;

    &::placeholder {
      color: @text-secondary;
    }

    &:focus {
      border-color: @brand-blue;
      box-shadow: 0 0 0 3px rgba(55, 136, 238, 0.1);
    }
  }

  .form-options {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 24px;

    .back-link {
      font-size: 13px;
      color: @text-secondary;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: @brand-blue;
      }
    }
  }

  .form-submit {
    .h-btn {
      height: 48px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 2px;
      border-radius: 8px;
      background: @brand-blue;
      border-color: @brand-blue;

      &:hover {
        opacity: 0.9;
        background: @brand-blue;
        border-color: @brand-blue;
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }

  .form-footer {
    margin-top: 24px;
    text-align: center;
    font-size: 13px;
    color: @text-secondary;
  }
}
</style>
